<template>
  <v-container class="confirmation-page text-xs-center">
    <!-- <div class="display-1">Thank you for registering {{ this.$route.query.id }} with the AWS Practice! You'll hear back from us soon.
    In the meantime, contact us at <a href="mailto:AWS-OppReg@cloud.dxc.com">AWS-OppReg@cloud.dxc.com</a> if you have any questions.</div> -->

    <div class="display-1">Thank you for submitting {{ this.$route.query.id }} with the AWS Practice! 
      The next steps in registration are outlined below and you’ll hear from us soon when the Opportunity Registration is approved back from AWS or if we need your help with any clarifications/item completions. 
      If you need status updates or have any questions, contact us at <a href="mailto:AWS-OppReg@cloud.dxc.com">AWS-OppReg@cloud.dxc.com</a>. </div>
    <v-stepper
      value="3"
      alt-labels>
      <v-stepper-header>
        <v-stepper-step
          step="1"
          complete>Submit DXC Galaxy Registration</v-stepper-step>
        <v-divider/>
        <v-stepper-step
          step="2"
          complete>DXC AWS Galaxy email sent to Registered Contact confirming submission</v-stepper-step>
        <v-divider/>
        <v-stepper-step step="3">NEXT STEP<br/>Galaxy team OppReg review</v-stepper-step>
        <v-divider/>
        <v-stepper-step step="4">Opportunity submitted to AWS for registration/validation</v-stepper-step>
        <v-divider/>
        <v-stepper-step step="5">AWS notifies DXC Galaxy team of approval</v-stepper-step>
        <v-divider/>
        <v-stepper-step step="6">DXC AWS Galaxy email notification to Registered Contact of AWS registration approval</v-stepper-step>
      </v-stepper-header>
    </v-stepper>
  </v-container>
</template>
<script>
export default {
  beforeRouteEnter (to, from, next) {
    if (!to.query.id) {
      history.back()
    } else {
      next()
    }
  }
  // mounted() {

  // }
}
</script>
<style lang="scss">

.confirmation-page {
  padding-top: 40px !important;

  .v-stepper {
    margin-top: 75px
  }

  .v-stepper__header {
    padding: 50px;
  }

  .v-stepper__label {
    text-align: center !important;
  }

  .v-stepper--alt-labels .v-stepper__header .v-divider {
    margin: 50px -60px 0;
  }

  .v-stepper__step__step {
    font-size: 20px;
    height: 50px;
    width: 50px;
    min-width: 50px;
  }

  .mdi-check:before {
    font-size: 100px;
    color: #000;
    position: relative;
    bottom: 15px;
    left: 12px;
  }
}
</style>
